import React, { useState } from 'react';
import { Text } from 'components/typography';
import { useModal } from 'store/modals';
import { Modal } from 'semantic-ui-react';
import { Button } from 'components/form-elements/buttons/Button';
import styles from './styles.module.scss';

export const ConfirmationModal = ({ title, content, onConfirm, onCancel }) => {
  const { closeModal } = useModal();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
      closeModal();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    closeModal();
  };

  return (
    <Modal
      size="small"
      centered
      dimmer="inverted"
      open
    >
      <Modal.Header>
        <Text
          center
          size={20}
        >
          {title}
        </Text>
      </Modal.Header>

      <Modal.Content>
        <Text
          center
          size={18}
        >
          {content}
        </Text>
      </Modal.Content>
      <Modal.Actions>
        <div className={styles.actions}>
          <Button
            intl="no"
            onClick={handleCancel}
            disabled={isLoading}
          />

          <Button
            intl="yes"
            onClick={handleConfirm}
            loading={isLoading}
            disabled={isLoading}
          />
        </div>
      </Modal.Actions>
    </Modal>
  ); 
};
